export const PASSWORD_POLICY_RULES = ['min_length', 'max_length', 'letter', 'digit'] as const;

export type PasswordPolicyRule = (typeof PASSWORD_POLICY_RULES)[number];

const MIN_LENGTH = 10;
const MAX_UTF8_BYTES = 72;

export const passwordUtf8Bytes = (password: string): number => new TextEncoder().encode(password).length;

export const isPasswordPolicyRule = (rule: string): rule is PasswordPolicyRule =>
  (PASSWORD_POLICY_RULES as readonly string[]).includes(rule);

export const evaluatePasswordPolicy = (password: string): Record<PasswordPolicyRule, boolean> => ({
  min_length: password.length >= MIN_LENGTH,
  max_length: passwordUtf8Bytes(password) <= MAX_UTF8_BYTES,
  letter: /\p{L}/u.test(password),
  digit: /\p{N}/u.test(password),
});

export const isPasswordPolicyMet = (password: string): boolean =>
  PASSWORD_POLICY_RULES.every((rule) => evaluatePasswordPolicy(password)[rule]);

export const getFailedPasswordPolicyRules = (password: string): PasswordPolicyRule[] =>
  PASSWORD_POLICY_RULES.filter((rule) => !evaluatePasswordPolicy(password)[rule]);
